module.exports = __webpack_public_path__ + "static/media/tshirt.25ed6c66.svg";